"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7168,4050],{

/***/ 64050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_CityBar; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(89583);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 5 modules
var _to_consumable_array = __webpack_require__(10797);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/CityBar/useCityBar.ts


var useCityBar = function(param) {
    var options = param.options, onSelect = param.onSelect, defaultValue = param.defaultValue;
    var ref = (0,react.useState)(options.find(function(option) {
        return option.slug === defaultValue;
    }) || options[0]), defaultOption = ref[0], setDefaultOption = ref[1];
    var ref1 = (0,react.useState)(options), filters = ref1[0], setFilters = ref1[1];
    var ref2 = (0,react.useState)(false), trigger = ref2[0], setTrigger = ref2[1];
    var boxRef = (0,react.useRef)(null);
    var ref3 = (0,react.useState)(""), value = ref3[0], setValue = ref3[1];
    var initOptions = (0,react.useRef)(options);
    (0,react.useEffect)(function() {
        var onMouseClick = function(e) {
            if (boxRef.current && !boxRef.current.contains(e === null || e === void 0 ? void 0 : e.target)) {
                setValue("");
                setTrigger(false);
                setFilters(initOptions.current);
            }
        };
        document.addEventListener("click", onMouseClick);
        return function() {
            document.removeEventListener("click", onMouseClick);
        };
    }, []);
    (0,react.useEffect)(function() {
        setFilters(options);
    }, [
        options
    ]);
    var OnOptionSelect = function(value, option) {
        onSelect === null || onSelect === void 0 ? void 0 : onSelect(value);
        setDefaultOption(option);
        setValue("");
        setTrigger(false);
        setFilters((0,_to_consumable_array/* default */.Z)(initOptions.current).concat([
            option
        ]));
    };
    var onSearch = function(e) {
        setValue(e.currentTarget.value);
        setFilters(options.filter(function(option) {
            return option.label.toLowerCase().includes(e.currentTarget.value.toLowerCase());
        }));
    };
    var onClickInput = function() {
        setFilters(initOptions.current);
    };
    return {
        OnOptionSelect: OnOptionSelect,
        defaultOption: defaultOption,
        trigger: trigger,
        value: value,
        boxRef: boxRef,
        setTrigger: setTrigger,
        setValue: setValue,
        onClickInput: onClickInput,
        filters: filters,
        onSearch: onSearch
    };
};

;// CONCATENATED MODULE: ./components/CityBar/Option.tsx


var Option = function(param) {
    var label = param.label, value = param.value, onClick = param.onClick, active = param.active;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: "city-option ".concat(active === true ? "city-option-active" : ""),
        title: label,
        onClick: function(e) {
            e.stopPropagation();
            e.preventDefault();
            onClick(value);
        },
        children: label
    });
};
Option.defaultProps = {
    active: false
};

;// CONCATENATED MODULE: ./components/CityBar/index.tsx







var CityBar = function(props) {
    var ref = useCityBar({
        options: props.options,
        onSelect: props.onSelect,
        defaultValue: props.defaultValue
    }), OnOptionSelect = ref.OnOptionSelect, defaultOption = ref.defaultOption, setValue = ref.setValue, setTrigger = ref.setTrigger, filters = ref.filters, trigger = ref.trigger, value = ref.value, boxRef = ref.boxRef, onSearch = ref.onSearch, onClickInput = ref.onClickInput;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        style: {
            zIndex: 9999999
        },
        className: "w-full text-white m-0 p-0 rounded-md bg-primary",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.style), {
                mixBlendMode: props.mode
            }),
            className: props.className + "w-full relative bg-primary rounded-md isolate",
            ref: boxRef,
            onClick: function() {
                if (!trigger) setTrigger(true);
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex justify-center items-center p-2 relative cursor-text rounded-md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            onClick: onClickInput,
                            placeholder: "",
                            "aria-label": "Select City",
                            title: "Select City",
                            className: "city-input",
                            value: value,
                            onBlur: function() {
                                setValue("");
                            },
                            onChange: function(e) {
                                var ref;
                                (ref = props.onSearch) === null || ref === void 0 ? void 0 : ref.call(props, e.currentTarget.value);
                                onSearch(e);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "flex-1 p-0 m-0",
                            children: defaultOption.label
                        }),
                        props.suffixIcon ? props.suffixIcon : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FaSearch */.U41, {})
                    ]
                }),
                trigger && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        zIndex: 9999999
                    },
                    className: "drop-down",
                    children: filters.map(function(option) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Option, {
                            active: defaultOption.slug === option.slug,
                            label: option.label,
                            value: option.slug,
                            onClick: function(value) {
                                return OnOptionSelect(value, option);
                            }
                        }, option.id);
                    })
                })
            ]
        })
    });
};
CityBar.defaultProps = {
    mode: "normal"
};
/* harmony default export */ var components_CityBar = (CityBar);


/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ })

}]);